// Plazos AEAT trimestrales (303/130): presentación del 1 al 20 del mes
// siguiente al cierre del trimestre (abril, julio, octubre, enero).
// Devuelve el próximo fin de plazo >= hoy y a qué trimestre corresponde.
export function nextQuarterDeadline(today = new Date()) {
  const y = today.getFullYear();
  const candidates = [
    { quarter: 4, year: y - 1, deadline: new Date(y, 0, 20) },
    { quarter: 1, year: y, deadline: new Date(y, 3, 20) },
    { quarter: 2, year: y, deadline: new Date(y, 6, 20) },
    { quarter: 3, year: y, deadline: new Date(y, 9, 20) },
    { quarter: 4, year: y, deadline: new Date(y + 1, 0, 20) },
  ];
  const todayMid = new Date(y, today.getMonth(), today.getDate());
  const next = candidates.find((c) => c.deadline >= todayMid);
  const daysLeft = Math.round((next.deadline - todayMid) / 86400000);
  return { quarter: next.quarter, year: next.year, deadline: next.deadline, daysLeft };
}

export function formatDeadline({ deadline }) {
  const dd = String(deadline.getDate()).padStart(2, "0");
  const mm = String(deadline.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${deadline.getFullYear()}`;
}

// Ventana de presentación AEAT: del día 1 al 20 del mes del deadline.
// Normaliza a medianoche (patrón todayMid de nextQuarterDeadline): un today
// con hora real NO debe cerrar la ventana durante el propio día 20.
export function windowProgress(today = new Date()) {
  const { deadline } = nextQuarterDeadline(today);
  const from = new Date(deadline.getFullYear(), deadline.getMonth(), 1);
  const todayMid = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const open = todayMid >= from && todayMid <= deadline;
  const pct = open ? Math.min(100, Math.max(0, Math.round((todayMid.getDate() / 20) * 100))) : 0;
  return { open, pct, from, to: deadline };
}
